import SimpleDate from 'app/common/classes/simple-date'


export type Params = {
  studentID: string
  supplierID: string
  dateFrom: SimpleDate
  dateTo: SimpleDate
}

export enum StatementStatus {
  Unknown = -1,
  Draft = 0,
  Consideration = 1,
  Processing = 2,
  Approved = 3,
  Denied = 4,
  Deleted = 5,
  Canceled = 6
}

export const isStatementStatus = (value: any): value is StatementStatus => {
  return typeof value === 'number' && Object.values(StatementStatus).includes(value)
}

export type Statement = {
  ID: string
  status: StatementStatus
  date: SimpleDate
  value: string
}

export type StatementList = Array<Statement>

export type DeleteStatementParams = {
  statementID: string
}
